import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'OverlaySpotTitle',
  props: {
    title: null,
    large: { type: Boolean }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h3", {
    class: _normalizeClass(["o-text-body font-bold text-10 mb-3 md:text-11 lg:text-12 xl:text-14", { 'text-14 sm:text-18 md:text-18 lg:text-18 xl:text-18': __props.large }])
  }, _toDisplayString(__props.title), 3))
}
}

})